import { useContext, useEffect, useState, useCallback } from "react";
import { toast } from "react-hot-toast";
import { GlobalContext } from "../../../../Context/GlobalContext";

/** tiny format helpers kept local */
const fmt = {
  dash: (v) => (v === null || v === undefined || v === "" ? "—" : v),
};

export default function useSettlement() {
  const { api, api2, baseUrl, adminId, latitude, longitude } =
    useContext(GlobalContext);

  const [clients, setClients] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busy, setBusy] = useState({});

  const setSpin = (id, action) => setBusy((p) => ({ ...p, [id]: action }));
  const clearSpin = (id) => setBusy((p) => ({ ...p, [id]: null }));

  const getWalletDetails = async (userid) => {
    try {
      const res = await api.post("/Transactions/getwalletBalanceV1", {
        userid,
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: res?.data?.response || {
            id: "",
            wallet_bal: "0",
            unsettled_Amount: "0",
          },
          message: res?.data?.responseMessage || "Balance fetched successfully",
        };
      } else {
        return {
          success: false,
          message:
            res?.data?.responseMessage || "Failed to fetch wallet balance",
          data: {
            id: "",
            wallet_bal: "0",
            unsettled_Amount: "0",
          },
        };
      }
    } catch (e) {
      console.error("getWalletDetails error:", e);

      return {
        success: false,
        message: "Error fetching wallet balance",
        data: {
          id: "",
          wallet_bal: "0",
          unsettled_Amount: "0",
        },
      };
    }
  };
  const getProcessedSettlements = async ({ userid, fromDate, toDate }) => {
    try {
      const res = await api.post("/Transactions/v1.0/getProcessedSettlements", {
        userid,
        fromDate,
        toDate,
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: res.data.response || [],
        };
      } else {
        return {
          success: false,
          message:
            res?.data?.responseMessage ||
            "Failed to fetch processed settlements",
          data: [],
        };
      }
    } catch (e) {
      console.error("getProcessedSettlements error:", e);
      return {
        success: false,
        message: "Error fetching processed settlements",
        data: [],
      };
    }
  };
  const getTransactionsReport = async ({ userid, fromDate, toDate }) => {
    try {
      const res = await api.post("/Transactions/getTransactionsReport", {
        userid,
        fromDate,
        toDate,
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: Array.isArray(res.data.response) ? res.data.response : [],
        };
      } else {
        return {
          success: false,
          message: res?.data?.responseMessage || "Failed to fetch transactions",
          data: [],
        };
      }
    } catch (e) {
      console.error("getTransactionsReport error:", e);
      return {
        success: false,
        message: "Error fetching transactions",
        data: [],
      };
    }
  };
  const getTransactionsAnalytics = async ({ userid, fromDate, toDate }) => {
    try {
      const res = await api.post(
        "/Transactions/v1.0/getTransactionsAnalytics",
        { userid, fromDate, toDate },
      );

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: res.data.response || null,
        };
      } else {
        return {
          success: false,
          message: res?.data?.responseMessage || "Failed to fetch analytics",
          data: null,
        };
      }
    } catch (e) {
      console.error("getTransactionsAnalytics error:", e);
      return {
        success: false,
        message: "Error fetching analytics",
        data: null,
      };
    }
  };
  const getAllSettlementsAnalytics = async ({ userid, fromDate, toDate }) => {
    try {
      const res = await api.post("/Order/getAllSettlementsAnalytics", {
        userid: String(userid),
        fromDate,
        toDate,
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: Array.isArray(res?.data?.response) ? res.data.response : [],
        };
      } else {
        return {
          success: false,
          message:
            res?.data?.responseMessage ||
            "Failed to fetch settlements analytics",
          data: [],
        };
      }
    } catch (e) {
      console.error("getAllSettlementsAnalytics error:", e);
      return {
        success: false,
        message: "Error fetching settlements analytics",
        data: [],
      };
    }
  };
  const getAllSettlements = async ({ userid, fromDate, toDate }) => {
    try {
      const res = await api.post("/Order/getAllSettlements", {
        userid: String(userid),
        fromDate,
        toDate,
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: Array.isArray(res?.data?.response) ? res.data.response : [],
        };
      } else {
        return {
          success: false,
          message: res?.data?.responseMessage || "No data",
          data: [],
        };
      }
    } catch (e) {
      console.error("getAllSettlements error:", e);
      return {
        success: false,
        message: "Failed to fetch settlements",
        data: [],
      };
    }
  };
  const processSettlementAbhi = async ({
    userid,
    fromDate,
    toDate,
    amount,
  }) => {
    try {
      const res = await api.post("/Admin/v1.0/processSettlementAbhi", {
        userid,
        fromDate,
        toDate,
        amount,
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          message:
            res?.data?.responseMessage || "Settlement processed successfully.",
        };
      } else {
        return {
          success: false,
          message: res?.data?.responseMessage || "Failed to process.",
        };
      }
    } catch (e) {
      console.error("processSettlementAbhi error:", e);
      return {
        success: false,
        message: "Error processing settlement.",
      };
    }
  };
  const getSettlementReport = async ({ userid, fromDate, toDate }) => {
    try {
      const res = await api.post("/Admin/v1.0/getSettlementReport", {
        userid,
        fromDate,
        toDate,
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: res.data.response || [],
        };
      } else {
        return {
          success: false,
          message:
            res?.data?.responseMessage || "Failed to fetch settlement report",
          data: [],
        };
      }
    } catch (e) {
      console.error("getSettlementReport error:", e);
      return {
        success: false,
        message: "Error fetching settlement report",
        data: [],
      };
    }
  };
  const getProcessedSettlementsAdmin = async ({ userid, fromDate, toDate }) => {
    try {
      const res = await api.post("/Admin/v1.0/getProcessedSettlements", {
        userid,
        fromDate,
        toDate,
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: res.data.response || [],
        };
      } else {
        return {
          success: false,
          message:
            res?.data?.responseMessage || "Failed to fetch settlement history",
          data: [],
        };
      }
    } catch (e) {
      console.error("getProcessedSettlementsAdmin error:", e);
      return {
        success: false,
        message: "Error fetching settlement history",
        data: [],
      };
    }
  };

  const processSettlement = async ({ userid, fromDate, toDate }) => {
    try {
      const res = await api.post("/Admin/v1.0/processSettlement", {
        userid,
        fromDate,
        toDate,
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          message:
            res?.data?.responseMessage || "Settlement processed successfully.",
        };
      } else {
        return {
          success: false,
          message: res?.data?.responseMessage || "Failed to process.",
        };
      }
    } catch (e) {
      console.error("processSettlement error:", e);
      return {
        success: false,
        message: "Error processing settlement.",
      };
    }
  };

  const processOrderTypeSettlement = async ({
    userid,
    orderType,
    fromDate,
    toDate,
  }) => {
    try {
      const res = await api.post("/Admin/v2.0/processSettlement", {
        userid,
        orderType,
        fromDate,
        toDate,
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          message:
            res?.data?.responseMessage ||
            "Order-type settlement processed successfully.",
        };
      } else {
        return {
          success: false,
          message: res?.data?.responseMessage || "Failed to process.",
        };
      }
    } catch (e) {
      console.error("processOrderTypeSettlement error:", e);
      return {
        success: false,
        message: "Error processing order-type settlement.",
      };
    }
  };
  const getAllPayouts = async ({ userid, fromDate, toDate }) => {
    try {
      const res = await api.post("/Transactions/getAllPayouts", {
        userid,
        fromDate,
        toDate,
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          data: res.data.response || [],
        };
      } else {
        return {
          success: false,
          message: res?.data?.responseMessage || "Failed to fetch payouts",
          data: [],
        };
      }
    } catch (e) {
      console.error("getAllPayouts error:", e);
      return {
        success: false,
        message: "Unable to fetch payout report.",
        data: [],
      };
    }
  };

  const settlementProcess = async ({ userid, amount, mode = "IMPS" }) => {
    try {
      const response = await api.post("/Transactions/settlementProccess", {
        userid,
        amount,
        mode,
      });

      if (response.data?.responseCode === "00") {
        return {
          success: true,
          message: response.data.responseMessage || "Settlement initiated.",
        };
      } else {
        return {
          success: false,
          message:
            response.data?.responseMessage || "Failed to process settlement.",
        };
      }
    } catch (e) {
      console.error("settlementProcess error:", e);
      return {
        success: false,
        message: "An error occurred while processing settlement.",
      };
    }
  };
  const getSettlementInvoices = async (userid) => {
    try {
      const res = await api.post("/Order/v1.0/getSettlementInvoices", {
        userid: String(userid),
      });

      if (
        res?.data?.responseCode === "00" &&
        Array.isArray(res.data.response)
      ) {
        return {
          success: true,
          data: res.data.response,
        };
      } else {
        return {
          success: false,
          message:
            res?.data?.responseMessage || "Failed to fetch settlement invoices",
          data: [],
        };
      }
    } catch (e) {
      console.error("getSettlementInvoices error:", e);
      return {
        success: false,
        message: "Error fetching settlement invoices",
        data: [],
      };
    }
  };
  const generateSettlementInvoices = async ({ userid, fromDate, toDate }) => {
    try {
      const res = await api.post("/Order/v1.0/generateSettlementInvoices", {
        userid: String(userid),
        fromDate,
        toDate,
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          message:
            res?.data?.responseMessage || "Invoices generated successfully.",
        };
      } else {
        return {
          success: false,
          message: res?.data?.responseMessage || "Failed to generate invoices.",
        };
      }
    } catch (e) {
      console.error("generateSettlementInvoices error:", e);
      return {
        success: false,
        message: "Error generating invoices.",
      };
    }
  };
  const getRestaurantWiseTransactions = async ({ userid, date }) => {
    try {
      const res = await api.post(
        "/Transactions/getRestaurantWiseTransactions",
        {
          userid: String(userid),
          date: String(date),
        },
      );

      // handle multiple possible shapes safely
      const data =
        res?.data?.response ||
        res?.data?.data ||
        res?.data?.result ||
        res?.data ||
        [];

      if (Array.isArray(data)) {
        return {
          success: true,
          data,
        };
      } else {
        return {
          success: false,
          message: "Invalid response format",
          data: [],
        };
      }
    } catch (e) {
      console.error("getRestaurantWiseTransactions error:", e);
      return {
        success: false,
        message:
          e?.response?.data?.responseMessage ||
          e?.message ||
          "Error fetching restaurant wise transactions",
        data: [],
      };
    }
  };
  const updateSettlementTransaction = async ({
    userid,
    orderid,
    pk_orderid,
    ordertype,
  }) => {
    try {
      const res = await api.post("/Transactions/updateSettlementTransactions", {
        userid: String(userid),
        orderid: String(orderid),
        pk_orderid: String(pk_orderid),
        ordertype: String(ordertype),
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          message:
            res?.data?.responseMessage ||
            res?.data?.message ||
            "Settlement transaction updated",
        };
      } else {
        return {
          success: false,
          message:
            res?.data?.responseMessage || res?.data?.message || "Update failed",
        };
      }
    } catch (e) {
      console.error("updateSettlementTransaction error:", e);

      return {
        success: false,
        message:
          e?.response?.data?.responseMessage || e?.message || "Update failed",
      };
    }
  };
  const updateOrderAmount = async ({
    userid,
    orderid,
    subtotal,
    orderAmount,
    payTotal,
    taxsgst,
    taxcgst,
    taxOnCommision,
    chaafoCommision,
    settlementAmount,
  }) => {
    try {
      const res = await api.post("/Order/UpdateOrderAmount", {
        userid: String(userid),
        orderid: String(orderid),
        subtotal: String(subtotal),
        orderAmount: String(orderAmount),
        payTotal: String(payTotal),
        taxsgst: String(taxsgst),
        taxcgst: String(taxcgst),
        taxOnCommision: String(taxOnCommision),
        chaafoCommision: String(chaafoCommision),
        settlementAmount: String(settlementAmount),
      });

      if (res?.data?.responseCode === "00") {
        return {
          success: true,
          message:
            res?.data?.responseMessage ||
            res?.data?.message ||
            "Payment details updated successfully",
        };
      } else {
        return {
          success: false,
          message:
            res?.data?.responseMessage ||
            res?.data?.message ||
            "Failed to update payment details",
        };
      }
    } catch (e) {
      console.error("updateOrderAmount error:", e);

      return {
        success: false,
        message:
          e?.response?.data?.responseMessage ||
          e?.message ||
          "Failed to update payment details",
      };
    }
  };
  const deleteUserSettlement = async ({ id, fkuserid }) => {
  try {
    const res = await api.post("/Admin/deleteUserSettlement", {
      id: Number(id),
      fkuserid: Number(fkuserid),
    });

    const apiMsg =
      res?.data?.response?.[0]?.message ||
      res?.data?.responseMessage ||
      "Deleted successfully";

    if (res?.data?.responseCode === "00") {
      return {
        success: true,
        message: apiMsg,
      };
    }

    return {
      success: false,
      message: apiMsg || "Failed to delete invoice",
    };
  } catch (e) {
    console.error("deleteUserSettlement error:", e);
    return {
      success: false,
      message:
        e?.response?.data?.responseMessage ||
        e?.message ||
        "Error deleting invoice",
    };
  }
};
  return {
    clients,
    orders,
    loading,
    busy,
    getWalletDetails,
    getProcessedSettlements,
    getTransactionsReport,
    getTransactionsAnalytics,
    getAllSettlementsAnalytics,
    getAllSettlements,
    processSettlementAbhi,
    getSettlementReport,
    getProcessedSettlementsAdmin,
    processSettlement,
    processOrderTypeSettlement,
    getAllPayouts,
    settlementProcess,
    getSettlementInvoices,
    generateSettlementInvoices,
    getRestaurantWiseTransactions,
    updateSettlementTransaction,
    updateOrderAmount,
    deleteUserSettlement,
  };
}
